export default __webpack_public_path__ + "static/Figtree-Medium-c07762d27ba64ebaa61249388521f97d.woff";